import { React, useState, useEffect } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import PDFToExcelUploadVie from "./PDFToExcelUploadView";
import { BASE_URL, MAX_UPLOAD_FILE_SIZE } from "../Config";

function PDFToExcelMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "PDF To Excel (.xls, .xlsx) Converter Online Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);
  //set progress
  //top loading bar
  const [progress, setProgress] = useState(0);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/pdf_to_excel", title: "Convert PDF To Excel Online" },
    data2: { link: "/pdf_to_excel", title: "PDF To Spreadsheet Converter" },
    data3: { link: "/pdf_to_excel", title: "PDF To XLSX Online" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
        setProgress,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar progress={progress} />

      {/*Add title and metadata */}
      <title>{title}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert PDF to Excel online instantly. Turn PDF tables into editable spreadsheets quickly with our fast, secure PDF to Excel converter."
      ></meta>
      <meta
        name="keywords"
        content="pdf to excel, convert pdf to excel, pdf to xls, pdf to xlsx, online pdf to excel, pdf spreadsheet converter, extract tables from pdf, pdf to excel online, pdf data to excel, pdf table extractor, pdf excel converter, editable excel from pdf, pdf document to excel, pdf to spreadsheet, pdf conversion tool, pdf to xls online, pdf to xlsx online, pdf to xls converter free, pdf xlsx converter free, pdf converter, pdf converter online, pdf to excel online free,"
      ></meta>

      {/* page content */}
      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={true} />
        {/* Upload PDF View */}
        {/* Upload View maxFileSize = 9.9mb */}
        {/* Runpod datauri size limit = 9.9mb */}
        {showEditFileScreen ? (
          <PDFToExcelUploadVie
            maxFileSize={MAX_UPLOAD_FILE_SIZE}
            allowedFileExtensions={["pdf"]}
          />
        ) : (
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
        )}
        {/* Mid Section */}
        <MiscPageMidSection description="Our PDF to Excel converter online website is a powerful and efficient solution for converting PDF documents into fully editable Excel spreadsheets with high accuracy. Designed to extract tables, rows, columns, and numerical data from PDF files, this advanced PDF to Excel online converter transforms static PDFs into Excel formats such as XLS and XLSX while preserving the original data structure as closely as possible. Whether you are an accountant managing financial reports, a business analyst working with data sheets, or a student handling assignments, this convert PDF to Excel online tool simplifies data editing and analysis. With an easy upload and convert process, users can quickly turn PDF files into Excel spreadsheets directly from their browser—no software installation required. Our PDF to Excel converter online ensures clean, well organized output that can be easily sorted, filtered, and recalculated in Microsoft Excel or other spreadsheet applications. Strong security practices are implemented to protect your documents, with files processed safely and removed automatically after conversion. By converting PDFs into editable Excel files, this tool saves time, reduces manual data entry, and improves productivity. If you’re searching for a fast, accurate, and secure PDF to Excel online converter that delivers professional results for data driven tasks, this website is the ideal choice for modern document conversion needs." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Select",
            step2: "Upload",
            step3: "Convert",
            step4: "Download",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="PDF To Excel Converter"
          why_use={[
            {
              title: "Convert PDFs into Editable Excel Files",
              description:
                "Our PDF to Excel converter online allows you to transform static PDF documents into fully editable Excel spreadsheets, making it easy to update, analyze, and manage data efficiently.",
            },

            {
              title: "Save Time and Reduce Manual Data Entry",
              description:
                "Using a convert PDF to Excel online tool eliminates the need to manually copy tables and numbers from PDFs, helping save time and minimize errors.",
            },

            {
              title: "Preserve Table Structure and Data Accuracy",
              description:
                "Our reliable PDF to Excel online converter accurately extracts rows, columns, and tables while maintaining data integrity and original structure.",
            },

            {
              title: "Improve Productivity and Workflow Efficiency",
              description:
                "With a fast PDF to Excel converter online website, professionals can quickly convert reports and datasets, streamlining daily tasks and boosting productivity.",
            },

            {
              title: "No Software Installation Required",
              description:
                "Our browser based PDF to Excel online tool works without installing software, allowing users to convert PDF to Excel instantly from any device.",
            },

            {
              title: "Ideal for Business and Financial Documents",
              description:
                "This PDF to Excel online converter is essential for handling invoices, financial statements, sales reports, and accounting data that require calculations and editing.",
            },

            {
              title: "Easy Data Editing and Analysis",
              description:
                "Converting PDF to Excel online enables sorting, filtering, formulas, and data visualization in Excel, which is not possible with static PDF files.",
            },

            {
              title: "Supports Large and Complex PDF Files",
              description:
                "Our advanced PDF to Excel converter online can process multi page PDFs and complex tables accurately, making it suitable for professional use.",
            },

            {
              title: "Secure and Reliable Online Conversion",
              description:
                "This secure PDF to Excel online website ensures safe file handling and protects sensitive information during the conversion process.",
            },
          ]}
        />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default PDFToExcelMain;
